import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChoiceListProps } from "./ChoiceList.types";

/** A list of choices for a modal, each with an icon, a title and a description. */
export function ChoiceList({ choices, disabled = false }: ChoiceListProps) {
  return (
    <div className="list-group">
      {choices.map((choice) => (
        <button
          className="list-group-item list-group-item-action d-flex align-items-center gap-3"
          disabled={disabled || choice.disabled}
          key={choice.title}
          onClick={choice.onClick}
          type="button"
        >
          <FontAwesomeIcon
            className={choice.iconClassName}
            fixedWidth
            icon={choice.icon}
          />
          <span className="flex-grow-1">
            <span className="fw-semibold d-block">{choice.title}</span>
            <span className="small text-muted">{choice.description}</span>
          </span>
          {choice.showSpinner && (
            <span
              aria-hidden="true"
              className="spinner-border spinner-border-sm"
              role="status"
            />
          )}
        </button>
      ))}
    </div>
  );
}

export default ChoiceList;
